// extracted by mini-css-extract-plugin
export default {"overlay":"EditorTour_overlay__pwSAz","welcomePopup":"EditorTour_welcomePopup__fzkAP","dummyTopElement":"EditorTour_dummyTopElement__wYDjU"};